"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FiltersSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,3 C11.209139,3 13,4.790861 13,7 C13,7.2006429 12.9887988,7.37261183 12.9663963,7.51590677 C14.180506,8.20261598 15,9.50560645 15,11 C15,13.209139 13.209139,15 11,15 C10.271376,15 9.58825351,14.8051848 8.99987956,14.4648015 C8.41251188,14.8049665 7.7290322,15 7,15 C4.790861,15 3,13.209139 3,11 C3,9.50560645 3.81949397,8.20261598 5.03360371,7.51590677 C5.0112047,7.34686296 5,7.17473998 5,7 C5,4.790861 6.790861,3 9,3 Z M5.30200941,8.52749838 C4.52278137,9.06033325 4,9.99405278 4,11 C4,12.6568542 5.34314575,14 7,14 C7.39828227,14 7.77843697,13.9223866 8.12616463,13.7814594 C7.42860086,13.0613619 6.85005188,11.8812408 7.03314346,10.4826921 C6.24401855,10.0695038 5.58474731,9.24058533 5.30200941,8.52749838 Z M9,4 C7.34314575,4 6,5.34314575 6,7 C6,8.65685425 7.34314575,10 9,10 C10.6568542,10 12,8.65685425 12,7 C12,5.34314575 10.6568542,4 9,4 Z" })));
};
FiltersSmall.displayName = 'FiltersSmall';
exports.default = FiltersSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FiltersSmall.js.map